export default {
  methods: {
    //Da usare con un VueDatePicker per l'inserimento di date nel formato gg/mm/aaaa
    pageDateInput(event){
        if (event.inputType.indexOf("deleteContent") == 0) {
            return;
        }
        let dayMonthRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])$/;
        if (dayMonthRegex.test(event.target.value)) {
            event.target.value += '/';
            return;
        }
        let dayRegex = /^(0[1-9]|[12][0-9]|3[01])$/;
        if (dayRegex.test(event.target.value)) {
            event.target.value += '/';
            return;
        }
    },

    //Da usare con un VueDatePicker per l'inserimento di date nel formato gg/mm/aaaa - gg/mm/aaaa
    pageDateInputRange(event) {
        if (event.inputType.indexOf("deleteContent") === 0) return;

        let val = event.target.value;
        let parts = val.split(' - ');

        if (parts.length === 1) {
            // Primo lato del range
            let first = parts[0];

            let dayRegex = /^(0[1-9]|[12][0-9]|3[01])$/;
            let dayMonthRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])$/;
            let fullDateRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/; // solo 4 cifre

            if (dayRegex.test(first)) {
                event.target.value = first + '/';
                return;
            }

            if (dayMonthRegex.test(first)) {
                event.target.value = first + '/';
                return;
            }

            if (fullDateRegex.test(first)) {
                event.target.value = first + ' - ';
                return;
            }
        } else if (parts.length === 2) {
            // Secondo lato del range
            let second = parts[1];

            let dayRegex = /^(0[1-9]|[12][0-9]|3[01])$/;
            let dayMonthRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])$/;

            if (dayRegex.test(second)) {
                event.target.value = parts[0] + ' - ' + second + '/';
                return;
            }

            if (dayMonthRegex.test(second)) {
                event.target.value = parts[0] + ' - ' + second + '/';
                return;
            }
        }
    }
  }
};
